function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 114.39941,
  cy: 51,
  r: 51,
  fill: "#ff6584"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M865.28907,651.55566a75.13107,75.13107,0,0,1-74.09765-62.75488l-.06055-.37109.23926-.28711a71.9858,71.9858,0,0,0,9.96679-15.70117,51.42563,51.42563,0,0,1-9.80078,8.31543l-1.20215.7998-.06933-1.44141c-.06055-1.24414-.09082-2.48046-.09082-3.67382a75.765,75.765,0,0,1,2.876-20.74219c8.72071-30.65137,10.21192-63.56641,4.43262-97.83008a107.23109,107.23109,0,0,1-1.4834-17.77978A105.99008,105.99008,0,0,1,1002.585,406.74463l.24121.72851-.71094.2876a55.20979,55.20979,0,0,1-16.78125,4.16358,72.00141,72.00141,0,0,0,18.63086,1.78955l.66114-.02295.16113.64258a106.44094,106.44094,0,0,1,3.15918,25.75586l-.00391.93994a47.31568,47.31568,0,0,0,15.62989,35.28027,75.10758,75.10758,0,0,1-3.50489,114.10547l-.3916.31641-.459-.209c-9.67285-4.38867-16.71973-9.16992-21.87305-14.877a73.22214,73.22214,0,0,0,13.68848,19.83887l.72754.75-.90332.52636a75.05745,75.05745,0,0,1-37.83692,10.21778l-.3789-.001c-.13379-.001-.26856-.001-.40235-.001-20.33691,0-39.6123,7.86426-52.94336,21.61231A75.682,75.682,0,0,1,865.28907,651.55566Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#f2f2f2"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M838.70638,769.90845a1.35562,1.35562,0,0,1-1.34047-1.16461c-.05759-.40468-5.69914-41.09222-.63239-95.16767,4.67917-49.94,19.70586-121.87111,64.72-180.947a1.35573,1.35573,0,1,1,2.15667,1.64342C858.98484,552.83833,844.07928,624.24167,839.4331,673.829c-5.03729,53.7608.56,94.131.61716,94.53264a1.3568,1.3568,0,0,1-1.34388,1.54678Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#3f3d56"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M861.2088,570.74389a1.35569,1.35569,0,0,1-.7981-2.45234,186.84807,186.84807,0,0,1,41.24943-20.99823c22.75805-8.33186,57.36506-15.88526,92.99237-4.54634a1.35554,1.35554,0,1,1-.82216,2.58341c-34.89738-11.10591-68.87707-3.6774-91.23795,4.50927a183.77853,183.77853,0,0,0-40.5877,20.64518A1.35031,1.35031,0,0,1,861.2088,570.74389Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#3f3d56"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M310.42466,669.22837c-12.647-.02307-32.5581.99726-43.40381,6.72357a89.88028,89.88028,0,0,0-22.49194,16.848,108.06892,108.06892,0,0,0-7.18359,8.21643,131.50351,131.50351,0,0,1-2.11-65.60328,7.3745,7.3745,0,0,0-11.47442-7.67376c-17.61933,12.84887-28.88385,34.6242-31.62336,56.65277-3.49047,28.06714,4.72852,56.35089,16.15168,82.23413l-.00354.01306c-.02118.11627-.05317.24316-.08466.37-.0423.19024-.095.38049-.13727.57067-.07434.3277-.15844.6659-.23279.9936l1.84967-.0846c.10584.05286.21161.09515.3169.148h46.32672a21.981,21.981,0,0,0,1.7124-2.11395c5.12635-7.02881,7.25061-16.552,9.8404-25.14508a128.12525,128.12525,0,0,1,7.01837-18.15857,131.93754,131.93754,0,0,1,28.65405-39.22394c.38037-.35931.77161-.71869,1.16278-1.0675,1.99249-1.83222,5.08106-4.28321,8.09924-6.58393A3.96163,3.96163,0,0,0,310.42466,669.22837Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#f2f2f2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M623.21411,232.42145a12.33392,12.33392,0,0,1-7.26936,15.6973,12.11787,12.11787,0,0,1-2.06455.56907l-7.0011,42.86807L590.456,276.39207l9.16619-38.38348a12.378,12.378,0,0,1,10.84306-13.582,12.052,12.052,0,0,1,12.7488,7.9948Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#9e616a"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M502.01184,329.55565s12.74635-16.8413,59.00006-16.38l26.25371-9.5387,6-55,21,5-3,68-45,26-59,12Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  points: "279.072 614.545 291.189 619.708 316.872 575.43 298.989 567.809 279.072 614.545",
  fill: "#9e616a"
});

var _ref10 = /*#__PURE__*/React.createElement("polygon", {
  points: "379.2 626.011 392.37 626.01 398.636 575.208 379.197 575.209 379.2 626.011",
  fill: "#9e616a"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M530.60231,769.387l40.50159-.00152v-.51221a15.76521,15.76521,0,0,0-15.76435-15.7641h-.001l-7.39814-5.61261L534.13716,753.11l-3.53552.00013Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#2f2e41"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M423.571,752.97692l37.25941,15.87813.20082-.4712a15.76519,15.76519,0,0,0-8.3215-20.68269l-.0009-.00038-4.60525-8.06384-14.899-.24786-3.2525-1.38606Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#2f2e41"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M543.98561,454.98421l20.01672,121.8841-5.44751,18.16284,7.14826,12.86358L555.2057,720.865l4.26111,9.38122-11.90552,7.34247h-24.226l-1.2857-102.27282L516.06532,620.3v-8.27558l-12.18219-62.36358-2.243,71.33618-3.54358,15.03937,2.97656,10.70813-3.88928,7.50195L463.85268,725.817H436.68739l2.101-16.18549h0c-4.86707-2.46417,7.30734-9.66618,8.4772-14.99461l-4-9,4-17,3.66762-33.21843L447.06538,565.3l1.82-94.42334,31.77832-24.30048Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#2f2e41"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  id: "ba239c3b-fb1a-4f53-9b5e-0d02c9b79e51",
  "data-name": "ab6171fa-7d69-4734-b81c-8dff60f9761b",
  cx: 343.37323,
  cy: 137.38085,
  r: 27.45257,
  fill: "#9e616a"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M447.538,505.542a10.80306,10.80306,0,0,0-5.91022-15.475l-.06488-38.39044L424.927,462.6874l2.61212,34.76812A10.86163,10.86163,0,0,0,447.538,505.542Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#9e616a"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "ac373832-f8f4-49a2-b77a-d6c2c8bc901b-1663",
  "data-name": "f348f81f-b961-4ae4-bc6b-758f6acfb12a",
  d: "M446.00032,335.67681l-7.43213-7.16358-5.45965,3.94059s-5.37159,6.44589-9.66883,25.78357,0,125.69488,0,125.69488l23.635-3.223-3.223-55.86441,9.66882-47.26987Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "currentColor"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M435.026,330.26061,460.06532,318.3l17-15.768,31-.232,10,13,26.40015,8.96783L540.06532,415.3l3,7s-2.09,1.88812-3.045,2.94406,1.31952,9.89651,1.31952,9.89651l1.28241,9.618L539.06538,447.3l4.624,5.462,1.148,8.60978s-80.71509-20.06177-95.96619,13.17236c-.80579,1.75589,1.17847-15.40494,1.17847-15.40494l1.98425-12.563-1.96851-11.27615-3-3,5.0315-5.0315-3.22571-23.874Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "currentColor"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  points: "544.516 614.005 529.657 614.005 522.586 556.692 544.516 556.692 544.516 614.005",
  fill: "#ffb6b6"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M704.225,769.387H693.56922l-1.902-10.06042-4.8714,10.06042h-28.262a6.353,6.353,0,0,1-3.61-11.581l22.56915-15.587V732.04818l23.73883,1.41687Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#2f2e41"
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  points: "689.025 584.524 676.244 592.103 640.927 546.414 659.79 535.228 689.025 584.524",
  fill: "#ffb6b6"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M860.76868,732.30408l-9.16528,5.43546-6.76767-7.683.94176,11.138-24.30871,14.41625a6.353,6.353,0,0,1-9.0124-8.11961l11.46133-24.91907-5.188-8.74809,21.141-10.89032Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#2f2e41"
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  points: "537.884 247.55 530.664 293.582 599.261 294.484 590.235 250.258 537.884 247.55",
  fill: "#ffb6b6"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M682.26561,422.63694l-19.59274,47.5166-1.42721,127.071L677.9651,718.551h18.50311l7.58089-119.34853,18.646-81.66293,18.38992,85.41095L798.26561,686.551h28.0979l-51.65774-92.125-5.97853-100.35385s3.72631-42.57268-15.344-67.69427l-4.64189-13.41078Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#2f2e41"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M778.23534,457.32906a13.54113,13.54113,0,0,1-8.6759-18.86421L740.37728,343.324l21.46461-4.2549,26.68995,93.258a13.61449,13.61449,0,0,1-10.2965,25.002Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#ffb6b6"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M743.616,410.60846l-51.28553-23.91275a6.18178,6.18178,0,0,1-5.85955-4.65686c-2.53491-10.03641-8.112-21.19261-5.15376-47.24413a37.99133,37.99133,0,0,1,43.18128-33.23389A38.00845,38.00845,0,0,1,755.874,348.83912c-5.95218,22.60362-5.31421,46.77456-5.99274,56.06465a6.16835,6.16835,0,0,1-4.941,5.58843h0a6.14953,6.14953,0,0,1-1.1928.11771C743.70354,410.60991,743.65988,410.60943,743.616,410.60846Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "currentColor"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M633.19318,250.82043a13.26706,13.26706,0,0,1-1.00079,1.834l24.5232,57.501,15.07345,1.84914.18259,23.11325-27.0027-.68027a10.084,10.084,0,0,1-9.4951-7.50353l-18.17637-68.75711a13.23154,13.23154,0,1,1,15.89572-7.35642Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#ffb6b6"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M659.1861,308.10608a5.66619,5.66619,0,0,1,4.5189-1.374l28.21149,3.81922a15.75292,15.75292,0,0,1,.4942,31.50185l-28.19711,4.54559a5.67225,5.67225,0,0,1-6.57416-5.52757l-.36543-28.64561A5.66588,5.66588,0,0,1,659.1861,308.10608Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "currentColor"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M739.06971,367.42354a5.66617,5.66617,0,0,1-2.88368-3.74067l-6.40756-27.73839a15.75292,15.75292,0,0,1,29.29011-11.606L773.295,349.10432a5.67227,5.67227,0,0,1-2.84455,8.10446l-26.6641,10.4752A5.66585,5.66585,0,0,1,739.06971,367.42354Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "currentColor"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 724.0208,
  cy: 266.32925,
  r: 29.00394,
  transform: "translate(-190.88816 250.28427) rotate(-28.66319)",
  fill: "#ffb6b6"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M704.06846,254.66982q-9.33421-.05253-18.66843-.10512c-.44262-4.24111,1.4449-8.46055,4.19494-11.719,2.7506-3.25856,6.312-5.71215,9.828-8.12489,3.56936-2.44954,7.26714-4.95468,11.51038-5.8108,3.55686-.71748,7.23305-.21961,10.82628.28q7.1481.994,14.29564,1.98789c5.23075.72735,10.70355,1.55,14.9519,4.68706,5.74553,4.24224,4.27668,14.03444,9.78935,18.5746,16.64941,13.71231,9.90836,25.68729,10.21887,38.1861q-30.17935,3.16557-60.35932,6.33126a16.59531,16.59531,0,0,1-6.57793-.19113c-2.11309-.646-4.05062-2.3952-4.2063-4.59914-.17387-2.46168,1.779-4.47655,3.36482-6.3672a29.74573,29.74573,0,0,0,2.56537-33.63609Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#2f2e41"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M488.21651,293.12614q-.17592-.38733-.35086-.77733c.04495.00144.08945.00791.1344.00908Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#2f2e41"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M467.02341,240.81362a7.64093,7.64093,0,0,1,4.78651-2.06947c1.77517.05721,3.57535,1.66053,3.20757,3.39818a28.211,28.211,0,0,1,33.95016-12.73041c4.41212,1.55663,8.73888,4.67081,9.7524,9.23835a8.32011,8.32011,0,0,0,1.04813,3.41026,3.893,3.893,0,0,0,4.14333,1.04969l.04355-.01284a1.29709,1.29709,0,0,1,1.56729,1.831l-1.24839,2.32827a10.00425,10.00425,0,0,0,4.76622-.10137,1.296,1.296,0,0,1,1.3762,2.01677,22.58934,22.58934,0,0,1-18.01175,9.2583c-4.988-.03041-10.02736-1.74951-14.88181-.60245a12.9269,12.9269,0,0,0-8.69453,18.14673c-1.49132-1.63118-4.37417-1.245-5.89967.35435a8.09142,8.09142,0,0,0-1.76663,6.19126,28.72622,28.72622,0,0,0,2.94915,9.64245,28.82633,28.82633,0,0,1-17.08773-51.3491Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#2f2e41"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M1012.46379,770.36306h-859.294a1.19069,1.19069,0,0,1,0-2.38137h859.294a1.19069,1.19069,0,1,1,0,2.38137Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#ccc"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M358.301,141.50732c-24.7168-3.34094-52.93512,10.01868-59.34131,34.12354a21.59653,21.59653,0,0,0-41.09351,2.1087l2.82971,2.02668a372.27465,372.27465,0,0,0,160.65882-.72638C404.16185,160.97089,383.01787,144.84821,358.301,141.50732Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#f0f0f0"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M252.301,209.50732c-24.7168-3.34094-52.93512,10.01868-59.34131,34.12354a21.59653,21.59653,0,0,0-41.09351,2.1087l2.82971,2.02668a372.27465,372.27465,0,0,0,160.65882-.72638C298.16185,228.97089,277.01787,212.84821,252.301,209.50732Z",
  transform: "translate(-151.8662 -129.63694)",
  fill: "#f0f0f0"
});

var SvgHighfive = function SvgHighfive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: 896.2676,
    height: 640.72612,
    viewBox: "0 0 896.2676 640.72612",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHighfive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/highfive.9a0ef372.svg";
export { ForwardRef as ReactComponent };